import React from 'react';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';

const TaxButtons = ({ onAddAnother, buttonClickValue, maxButtonClick }) => (
  <ActionButton.Add
    labelText={<Content id="addButton" />}
    onClick={(e) => {
      e.preventDefault();
      if (buttonClickValue <= maxButtonClick) {
        onAddAnother();
      }
    }}
    disabled={buttonClickValue > maxButtonClick}
    type="button"
  />
);

TaxButtons.propTypes = {
  onAddAnother: PropTypes.func.isRequired,
  buttonClickValue: PropTypes.number.isRequired
};

TaxButtons.defaultProps = {
  maxButtonClick: 4
};
export default TaxButtons;
